<template>
  <div id="staffManage">
    <div class="staff-head">
      <div class="staff-head-left">
        <span class="staffNum">当前账号可选择{{ maxUsedMemberNum }}名员工</span>
        <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
        >
          <span slot="reference" style="color: #409eff;cursor: pointer">如何获取更多员工？</span>
          <span style='color: gray;display: flex;justify-content: flex-start;margin-bottom: 10px'>请扫描下方二维码添加您的专属客户成功获取</span>
          <span>
            <img src="https://guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com/askbot_code.png" style="width: 200px"/>
          </span>
        </el-popover>
      </div>
      <div class="staff-head-right">
        <span class="remainStaff">剩余:{{ remainStaffNum }}</span>
        <el-button type="primary" size="small" @click="openStaffDialog">使用员工管理</el-button>
      </div>
    </div>
    <div class="staff-container">
      <el-table
          :data="memberList"
          :fit="true"
          height="calc(100vh - 175px)"
      >
        <el-table-column
            label="姓名"
            min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="部门"
            min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.departmentFullName">{{ scope.row.departmentFullName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
            label="手机"
            min-width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.mobile">{{ scope.row.mobile }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
            label="邮箱"
            min-width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.email">{{ scope.row.email }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
            label="线索数"
            width="100"
            align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.clueNum }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="associatedAccount(scope.row)">关联平台账号</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        title="选择员工"
        :visible.sync="memberdialogVisible"
        width="600px"
        append-to-body
        class="memberDialog"
    >
      <staff-dialog ref="staffDialog" :maxNum="maxUsedMemberNum"></staff-dialog>
      <div class="footer-show">
        <div class="staff-head-left">
          <span class="staffNum">当前账号可选择{{ maxUsedMemberNum }}名员工</span>
          <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
          >
            <span slot="reference" style="color: #409eff;cursor: pointer">如何获取更多员工？</span>
            <span style='color: gray;display: flex;justify-content: flex-start;margin-bottom: 10px'>请扫描下方二维码添加您的专属客户成功获取</span>
            <span>
             <img src="https://guoranopen-zjk.oss-cn-zhangjiakou.aliyuncs.com/askbot_code.png" style="width: 200px"/>
          </span>
          </el-popover>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="memberdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmMember">确 定</el-button>
        </span>
      </div>

    </el-dialog>
    <el-dialog
        title="选择关联平台账号"
        :visible.sync="accountDialogVisible"
        width="500px"
        top="8vh"
    >
      <div class="account-list">
        <div class="account-item"
             v-for="item in accountList"
             :key="item.id"
             @click="checkAccount(item)"
        >
          <div class="account-item-left">
            <span class="user-name" v-if="item.username">{{item.username}}</span>
            <span class="real-name" v-if="item.realName">({{item.realName}})</span>
          </div>
          <div class="account-item-right">
<!--            <el-radio-group v-model="accountId">-->
<!--              <el-radio :label="item.id"></el-radio>-->
<!--            </el-radio-group>-->
            <i class="el-icon-check" v-if="item.checked"></i>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accountDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindAssociatedAccount">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import StaffDialog from "@/views/staffManage/compontent/staffDialog";

export default {
  name: "staffManage",
  components: {StaffDialog},
  data() {
    return {
      remainStaffNum: 0,
      tableData: [],
      memberdialogVisible: false,
      memberList:[],
      memberIds:[],
      maxUsedMemberNum:0,
      memberLists:[],
      accountDialogVisible:false,
      accountList:[],
      accountId:'',
      memberDetail:{},
      accountDetail:'',
      usedMemberBindAccounts:{}
    }
  },
  mounted() {
    this.getUserIds()
    this.getAccounts()

  },
  methods: {
    //关联平台账号
    associatedAccount(item){
      this.memberDetail = item
      this.accountDialogVisible = true
      this.accountDetail = ''
      this.accountList.forEach(account=>{
        this.$set(account,'checked',false)
      })
      let id = this.usedMemberBindAccounts[this.memberDetail.userid]
      this.accountList.forEach(account=>{
        if (account.id===id){
          this.$set(account,'checked',true)
        }
      })
    },
    //
    checkAccount(item){
      this.accountList.forEach(account=>{
        this.$set(account,'checked',false)
      })
      this.$set(item,'checked',true)
      this.accountDetail = item
    },
    //关联账号
    bindAssociatedAccount(){
      console.debug('memberDetail',this.memberDetail)
      if (!this.accountDetail){
        this.$message({
          message:'请选择关联平台账号',
          duration:2000,
          type:'warning'
        })
        return
      }
      if (this.accountDetail){
        let url = '/scrm-api/we-work-admin-v2/bind-authed-select-info?memberId='+this.memberDetail.userid + '&askbotAccountId=' + this.accountDetail.id
        this.$http.post(url).then(res=>{
          if (res.status===200){
            this.$message({
              message:'关联平台账号成功',
              duration:2000,
              type:'success'
            })
            this.accountDialogVisible = false
            this.getUserIds()
          }
        })
      }
    },
    openStaffDialog() {
      this.memberdialogVisible = true
      this.$nextTick(()=>{
       /* let tags =[]
        for (let i=0;i<this.memberList.length;i++){
          tags.push({name:this.memberList[i].name,id:this.memberList[i].userid})
        }
        this.$refs.staffDialog.tags = tags*/


        let ids = this.memberIds
        setTimeout(() => {
          this.$refs.staffDialog.initShowOrTree(ids,true,"init")
        }, 1000);
        this.$refs.staffDialog.memberIds = ids
        this.$refs.staffDialog.$refs.tree.setCheckedKeys(ids)
        /*this.$refs.staffDialog.tagsList=this.memberLists
        this.$refs.staffDialog.getMemberTags(this.memberLists)*/
      })
    },
    confirmMember(){
      let url='/scrm-api/we-work-admin-v2/init-authed-select-info'
      let ids=this.$refs.staffDialog.originMember
      if (ids.length===0){
        this.$message({
          message:'请选择使用员工',
          type:'warning',
          duration:2000
        })
        return
      }
      this.$http.post(url,ids).then(res=>{
        if (res.status===200){
          this.memberdialogVisible = false
          this.getUserIds()
        }
      })
    },
    //获取账号列表
    getAccounts(){
      let url ='/scrm-api/intermediate/askbot-accounts'
      this.$http.get(url).then(res=>{
        if (res.status===200){
          this.accountList = res.data
        }
      })
    },
    getUserIds(){
      this.$http.get('/scrm-api/we-work-auth-info').then(res=>{
        if (res.status===200){
          console.debug('work-auth-info',res.data)
          this.usedMemberBindAccounts = res.data.usedMemberBindAccounts?res.data.usedMemberBindAccounts:{}
          if (res.data.maxUsedMemberNum){
            this.maxUsedMemberNum=res.data.maxUsedMemberNum
          }
          if (res.data.usedMemberIds){
            this.memberIds=JSON.parse(JSON.stringify(res.data.usedMemberIds))
          }
          this.getUseMemberList(this.memberIds)
        }
      })
    },
    getUseMemberList(memberIds){
      let url='/scrm-api/intermediate/members-info?withClueNum=true'
      this.$http.post(url,memberIds).then(res=>{
        if (res.status===200){
          this.memberList=JSON.parse(JSON.stringify(res.data))
          this.getMemberTags(memberIds)
        }
      })
    },
    getMemberTags(memberIds) {
      let url = '/scrm-api/we-work/member'
      this.$http.get(url).then(res => {
        this.memberLists=JSON.parse(JSON.stringify(res.data))
        if (res.status === 200) {
          let tags = this.getdepatmentMember(res.data[0],[],memberIds)
          let obj = {};
          let peon = tags.reduce((cur, next) => {
            obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
            return cur;
          }, [])
          this.remainStaffNum = this.maxUsedMemberNum-peon.length
        }
      })
    },
    getdepatmentMember(data, memberTags, id) {
      var children = [];
      if (data) {
        if (id.indexOf(data.id) !== -1&&data.isMember) {
          memberTags.push(data)
        }
        if (data.children) {
          children = data.children
        }
      }
      for (var child of children) {
        //每遍历一个子元素，就输出元素名
        this.getdepatmentMember(child, memberTags, id);
      }
      return memberTags
    },

  }
}
</script>

<style scoped lang="less">
#staffManage {
  .staff-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;

    background-color: white;

    .staff-head-left {
      padding-left: 20px;

      .staffNum {
        margin-right: 12px;
      }
    }

    .staff-head-right {
      padding-right: 50px;

      .remainStaff {
        margin-right: 12px;
      }

    }
  }

  .staff-container {
    margin: 10px 35px 10px 15px;
    background-color: white;
    height: calc(100vh - 120px);
    width: calc(100vw - 170px);
    overflow: hidden;
  }
  .account-list{
    height: calc(100vh - 300px);
    overflow-y: scroll;
    overflow-x: hidden;
    .account-item{
      padding: 4px 10px 4px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      min-height: 28px;
      .user-name{
        padding-right: 6px;
      }
      .account-item-right{
        i{
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
  }
}
.memberDialog{
  .footer-show{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }
}
</style>